module.exports = __webpack_public_path__ + "img/IMG_9621_L_Wood_MockedUp.ca6c9569.jpg";